module.exports = __webpack_public_path__ + "static/Calm-97a3a6cefc8a88cf409602e54a588350.jpg";